export const PageText = {
  _1: 'What is the difference between the “aircheckr AQI” and “aircheckr AQ comparison”?',
  _2: 'aircheckr gives you several options to understand the air quality for a specific place. The aircheckr Air Quality Index and the aircheckr AQ comparison (to the normal situation) are two of them. Learn more about the differences between them here.'
};

export const Categories = {
  _1: {
    title: 'AQI',
    subcategories: [
      {
        key: 0,
        subtitle: 'Absolute indication',
        text: 'The aircheckr AQI gives an absolute, health-based indication on the air quality. The thresholds of these AQI are independent of your location and are the same all around the world.'
      }
    ]
  },
  _2: {
    title: 'AQ Comparison',
    subcategories: [
      {
        key: 0,
        subtitle: 'Relative indication for your location',
        text: 'The aircheckr AQ Comparison is only a relative (and not health-based) indication of the air quality for a requested location. It gives an idea on how good the air is at this specific location compared with the air you can normally find for this area. More specifically, this means that all values of the last full year are ranked and split in 5 equal groups of values.'
      }
    ],
    percentGroups: [
      {
        group: '0%-20%',
        label: 'Much better'
      },
      {
        group: '20%-40%',
        label: 'Better'
      },
      {
        group: '40%-60%',
        label: 'Average situation'
      },
      {
        group: '60%-80%',
        label: 'Worse'
      },
      {
        group: '80%-100%',
        label: 'Much worse'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/difference-between-aqi-and-aq-comparison_page.js